import { isGlobalManager } from "../forms/formSource";
import type {
  OrganisationRole,
  UserOrganisation,
} from "../../types/organisation";

export type { OrganisationRole, UserOrganisation };

export function getOrganisationMembership(
  organisations: UserOrganisation[],
  organisationId: number | null | undefined,
): UserOrganisation | null {
  if (organisationId == null) return null;
  return organisations.find((org) => org.id === organisationId) ?? null;
}

export function canManageOrganisations(roles: string[]): boolean {
  return isGlobalManager(roles);
}

export function canManageOrgMembers(
  roles: string[],
  organisations: UserOrganisation[],
  organisationId: number,
): boolean {
  if (isGlobalManager(roles)) return true;
  const membership = getOrganisationMembership(organisations, organisationId);
  return membership?.role === "org_admin";
}

export function canCreateForms(
  roles: string[],
  organisations: UserOrganisation[],
): boolean {
  if (isGlobalManager(roles)) return true;
  return organisations.some(
    (org) => org.role === "org_admin" || org.role === "form_manager",
  );
}

/** CRUD формы, answer-share, удаление ответов. */
export function canManageForm(
  roles: string[],
  organisations: UserOrganisation[],
  organisationId: number | null | undefined,
): boolean {
  if (isGlobalManager(roles)) return true;
  if (organisationId == null) return false;

  const membership = getOrganisationMembership(organisations, organisationId);
  return (
    membership?.role === "org_admin" || membership?.role === "form_manager"
  );
}

/** Просмотр формы и ответов (form_viewer+). */
export function canViewForm(
  roles: string[],
  organisations: UserOrganisation[],
  organisationId: number | null | undefined,
): boolean {
  if (isGlobalManager(roles)) return true;
  if (organisationId == null) return false;
  return getOrganisationMembership(organisations, organisationId) != null;
}

export function organisationRoleLabel(role: OrganisationRole): string {
  switch (role) {
    case "org_admin":
      return "Админ организации";
    case "form_manager":
      return "Менеджер форм";
    case "form_viewer":
      return "Просмотр";
    default:
      return role;
  }
}
